/**
 * Реферальная программа: задания и награды в минимальных единицах PAWS.
 */
import { PAWS_SCALE } from "./money.js";
export const REFERRAL_SUBSCRIBE_REWARD_PAWS = (15n * PAWS_SCALE).toString();
export const REFERRAL_INVITE_1_REWARD_PAWS = (15n * PAWS_SCALE).toString();
export const REFERRAL_INVITE_10_REWARD_PAWS = (100n * PAWS_SCALE).toString();
export const REFERRAL_INVITE_100_REWARD_PAWS = (1000n * PAWS_SCALE).toString();
export const REFERRAL_TASKS = [
    {
        kind: "subscribe_channel",
        title: "Подпишись на @koshkodrop",
        description: "Подпишись на наш канал с новостями и дропами",
        rewardPaws: REFERRAL_SUBSCRIBE_REWARD_PAWS,
        requiredInvites: null,
    },
    {
        kind: "invite_1",
        title: "Пригласи друга",
        description: "Друг должен зарегистрироваться и пополнить баланс",
        rewardPaws: REFERRAL_INVITE_1_REWARD_PAWS,
        requiredInvites: 1,
    },
    {
        kind: "invite_10",
        title: "Пригласи 10 друзей",
        description: "10 друзей с пополнением баланса",
        rewardPaws: REFERRAL_INVITE_10_REWARD_PAWS,
        requiredInvites: 10,
    },
    {
        kind: "invite_100",
        title: "Пригласи 100 друзей",
        description: "100 друзей с пополнением баланса",
        rewardPaws: REFERRAL_INVITE_100_REWARD_PAWS,
        requiredInvites: 100,
    },
];
/** Парсит start_param реферальной ссылки: ref_123456789. */
export function parseReferrerTelegramId(startParam) {
    if (!startParam)
        return null;
    const trimmed = startParam.trim();
    const match = /^ref[_-]?(\d+)$/i.exec(trimmed);
    if (!match?.[1])
        return null;
    try {
        return BigInt(match[1]);
    }
    catch {
        return null;
    }
}
/** Ссылка для шаринга: сразу открывает мини-апп с рефералом в start_param. */
export function buildReferralLink(botUsername, telegramId) {
    const username = botUsername.replace(/^@+/, "");
    const id = typeof telegramId === "bigint" ? telegramId.toString() : telegramId;
    return `https://t.me/${username}?startapp=ref_${id}`;
}
//# sourceMappingURL=referrals.js.map